import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import '../App.css';

// Componentes
import ConfigPanel from './components/ConfigPanel';

// Páginas
import InvoiceSearchPage from './pages/InvoiceSearchPage';
import InvoiceDetailPage from './pages/InvoiceDetailPage';
import RecordatorioDetailPage from './pages/RecordatorioDetailPage';
import PaymentConfirmationPage from './pages/PaymentConfirmationPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PaymentPendingPage from './pages/PaymentPendingPage';
import PaymentFailedPage from './pages/PaymentFailedPage';

const App: React.FC = () => {
  const [showConfig, setShowConfig] = useState(false);

  // Mostrar/ocultar panel de configuración con Ctrl+Shift+D
  React.useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.shiftKey && e.key === 'D') {
        e.preventDefault();
        setShowConfig(prev => !prev);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <Router>
      {/* Panel de configuración oculto, se muestra con Ctrl+Shift+D */}
      {showConfig && (
        <div style={{ padding: '20px', background: '#f8f9fa', borderBottom: '1px solid #dee2e6' }}>
          <ConfigPanel />
          <p style={{ textAlign: 'center', margin: '10px 0 0 0', fontSize: '12px', color: '#666' }}>
            Presiona Ctrl+Shift+D para ocultar este panel
          </p>
        </div>
      )}

      <Routes>
        <Route path="/" element={<InvoiceSearchPage />} />
        <Route path="/invoice/:id" element={<InvoiceDetailPage />} />
        <Route path="/recordatorio/:nro" element={<RecordatorioDetailPage />} />
        <Route path="/payment-confirmation" element={<PaymentConfirmationPage />} />
        <Route path="/payment/success" element={<PaymentSuccessPage />} />
        <Route path="/payment/pending" element={<PaymentPendingPage />} />
        <Route path="/payment/failed" element={<PaymentFailedPage />} />
      </Routes>
    </Router>
  );
};

export default App; 